import React from 'react'

function Stats() {
    return ( 
       <div className='container mt-5 p-5 '>
            <h2>Trust With Confidence</h2>
                <div className='row p-5'>
                    <div className='col-6 p-5'>
                        <h3>Customer-first always</h3>
                        <p>That's why 1.5+ crore customers trust Zerodha with ₹4.5+ lakh crores of equity investments and contribute to 15% of daily retail exchange volumes in India.</p>
                        <h3>No spam or gimmicks</h3>
                        <p>No gimmicks, spam, "gamification", or annoying push notifications. High quality apps that you use at your pace, the way you like.</p>
                        <h3>The Zerodha universe</h3>
                        <p>Not just an app, but a whole ecosystem. Our investments in 30+ fintech startups offer you tailored services specific to your needs.</p>
                    </div>
                    <div className='col-6'>
                        <img src='media/features.png' alt='features' style={{width:"90%"}}></img>
                        <div className='text-center'>
                            <a href='#'className='mx-5' style={{textDecoration:"none"}}>Explore our products</a>
                            <a href='#' style={{textDecoration:"none"}}>Try Kite Demo</a>
                        </div>    
                    </div>
                    <img src='media/recognition.png' alt='recognition' className='mx-5' style={{width:"75%"}}></img>
                </div>

            
        </div>
     );
}

export default Stats;